module.exports = __webpack_public_path__ + "media/images/front/materiales_inf_m-b3ee6543e47fb1ff8bd071746b160faf.webp";